import { FC, ReactNode } from 'react';

type LeadsLayoutProps = {
  children: ReactNode;
};

/** Minimal layout wrapper that isolates Leads CRM from community dashboard data flows. */
export const LeadsLayout: FC<LeadsLayoutProps> = ({ children }) => (
  <div className="min-h-screen w-full bg-surface-canvas text-ink">{children}</div>
);

export default LeadsLayout;
